import * as React from "react";
import { fetchUtils, Admin, Resource, CustomRoutes, HttpError } from 'react-admin';
import { Route } from "react-router-dom";
import { BrowserRouter } from 'react-router-dom';

import authProvider from './providers/auth/authProvider';
import simpleRestProvider from './providers/data/dataProvider';
import { addSentryBreadcrumb, captureRequestFailure } from './monitoring/sentry';
import { isJwtExpired } from './utils';
import { Login } from './components/Login';
import { ForgotPassword } from './components/ForgotPassword';
import { ChangePassword } from './components/ChangePassword';
import orders from "./resources/orders/";
import events from "./resources/events/";
import files from "./resources/files/";
import {myTheme} from "./theme";
/* import { InstallApp } from "./components/InstallApp"; */

const getValidToken = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    return null;
  }

  try {
    return isJwtExpired(token) ? null : token;
  } catch {
    localStorage.removeItem('token');
    return null;
  }
};

const httpClient = async (url, options = {}) => {
  const { skipCaptureStatuses = [], ...fetchOptions } = options;

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers({ Accept: 'application/json' });
  }

  const token = getValidToken();
  if (!token) {
    throw new HttpError('Authentication required', 401, { message: false });
  }

  fetchOptions.headers.set('Authorization', `Bearer ${token}`);
  fetchOptions.headers.set('Access-Control-Allow-Origin', 'http://localhost:3001, http://localhost:3000,');

  const method = fetchOptions.method || 'GET';
  const startedAt = Date.now();

  try {
    const response = await fetchUtils.fetchJson(url, fetchOptions);

    addSentryBreadcrumb({
      category: 'http',
      message: 'API request succeeded',
      data: {
        method,
        url,
        status: response.status,
        durationMs: Date.now() - startedAt,
      },
    });

    return response;
  } catch (error) {
    if (skipCaptureStatuses.includes(error.status)) {
      addSentryBreadcrumb({
        category: 'http',
        message: 'API request failed with expected status',
        level: 'info',
        data: {
          method,
          url,
          status: error.status,
          durationMs: Date.now() - startedAt,
        },
      });
      throw error;
    }

    captureRequestFailure({
      error,
      operation: 'react_admin_http_client',
      url,
      method,
      extra: {
        durationMs: Date.now() - startedAt,
      },
    });

    throw error;
  }
};

const dataProvider = simpleRestProvider(process.env.REACT_APP_API_URL, httpClient);

const App = () => (
  <BrowserRouter>

    <Admin
      theme={myTheme}
      loginPage={Login}
      //dashboard={Dashboard}
      dataProvider={dataProvider}
      authProvider={authProvider}
      requireAuth
      title="Example Admin">

      <CustomRoutes noLayout>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </CustomRoutes>
      <Resource name="orders" {...orders} />
      <Resource name="events" {...events} />
      <Resource name="files" {...files} />
    </Admin>
{/*     <InstallApp/> */}
  </BrowserRouter>
);

export default App;
